











import Vue from 'vue';
import avvocatoEdit from '@/components/commands/AvvocatoEdit.vue';

export default Vue.extend({
    components: { avvocatoEdit },
    methods: {
        close() {
            this.$router.push({
                name: 'AvvocatoList',
            });
        },
    },
});
